import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { useState } from 'react';
import { Button, ButtonGroup, Content, Dialog, Divider, Heading, ProgressCircle, Text } from '@adobe/react-spectrum';
import { messages } from '../Messages';
import { useTypedMessageFormatter, useValue } from '../utils/util';
import { SpectrumFlex } from '../flex/SpectrumFlex';
import { SpectrumView } from '../view/SpectrumView';
export function SpectrumWizard(props) {
    const [pageIndex, setPageIndex] = useState(0);
    const [finishRunning, setFinishRunning] = useState(false);
    const [title,] = useValue(props.title);
    const m = useTypedMessageFormatter(messages);
    const { actionProgressLabel = m('SpectrumWizard.actionprogress.label'), finishLabel = m('SpectrumWizard.finish.label') } = props;
    const movePrev = (evt) => {
        if (finishRunning) {
            return;
        }
        const prevIdx = pageIndex - 1;
        if (prevIdx == 0) {
            evt.target.blur();
        }
        if (prevIdx >= 0) {
            setPageIndex(prevIdx);
        }
    };
    const moveNext = (evt) => {
        if (finishRunning) {
            return;
        }
        const nextIdx = pageIndex + 1;
        if (nextIdx + 1 === props.pages.length) {
            evt.target.blur();
        }
        if (nextIdx + 1 <= props.pages.length) {
            setPageIndex(pageIndex + 1);
        }
    };
    const onFinish = (evt) => {
        if (finishRunning) {
            return;
        }
        evt.target.blur();
        const rv = props.onFinish();
        if (rv) {
            setFinishRunning(true);
            rv.catch(() => setFinishRunning(false));
        }
    };
    const onCancel = () => {
        if (finishRunning) {
            return;
        }
        props.onCancel();
    };
    return _jsxs(Dialog, Object.assign({ width: props.overviewWidth + props.contentViewPortWidth + 30 }, { children: [_jsx(Heading, { children: title }), _jsx(Divider, {}), _jsx(Content, Object.assign({ height: props.contentViewPortHeight }, { children: _jsxs(SpectrumFlex, Object.assign({ direction: "row", columnGap: "size-200", overflow: "hidden", height: "100%" }, { children: [_jsx(SpectrumFlex, Object.assign({ direction: "column", rowGap: "size-125", minWidth: props.overviewWidth }, { children: props.pages.map((v, idx) => { return _jsx("span", Object.assign({ style: { whiteSpace: 'nowrap', fontWeight: pageIndex == idx ? 'bold' : undefined } }, { children: _jsx(Text, { children: _jsxs(_Fragment, { children: [idx + 1, ". ", v.title] }) }) }), 'page-nav-' + idx); }) })), _jsx(Divider, { orientation: "vertical" }), _jsx(SpectrumView, Object.assign({ overflow: "hidden auto", flexGrow: 1 }, { children: _jsx(SpectrumFlex, Object.assign({ alignItems: "stretch", direction: "column", overflow: "hidden", width: "100%" }, { children: props.pages[pageIndex].page })) }))] })) })), _jsxs(ButtonGroup, { children: [_jsx(Button, Object.assign({ id: "PrevButton", variant: "secondary", isDisabled: pageIndex - 1 < 0, onPress: movePrev }, { children: m('SpectrumWizard.prev.label') })), _jsx(Button, Object.assign({ id: "NextButton", variant: "secondary", isDisabled: pageIndex + 1 === props.pages.length, autoFocus: true, onPress: moveNext }, { children: m('SpectrumWizard.next.label') })), _jsxs(Button, Object.assign({ id: "EndButton", variant: "cta", isDisabled: pageIndex + 1 !== props.pages.length, onPress: onFinish }, { children: [finishRunning && _jsxs(_Fragment, { children: [_jsx(ProgressCircle, { size: "S", "aria-label": actionProgressLabel, isIndeterminate: true, marginEnd: 5 }), _jsx(Text, { children: actionProgressLabel })] }), !finishRunning && _jsx(Text, { children: finishLabel })] })), _jsx(Button, Object.assign({ id: "AbortButton", variant: "primary", onPress: onCancel }, { children: m('SpectrumWizard.cancel.label') }))] })] }));
}
